export default __webpack_public_path__ + "static/media/evernote.c8a70b3d.svg";